import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Autoplay from "embla-carousel-autoplay";
import { Carousel, CarouselContent, CarouselItem } from './ui/Carousel';
import Certificate from '../assets/certificate.webp';
import Slider2 from '../assets/slider2.webp';
import Slider3 from '../assets/slider3.webp';
import Workshop from '../assets/workshop.webp';
import LeapDeep from '../assets/leap-deep.webp';

export function ExploreMoreAboutMe() {

    const media = [
        { type: "image", src: Slider2, text: "Regional Scrum Gathering" },
        { type: "video", src: "https://www.youtube.com/embed/XGwWBJWtQ50?si=MhEiNPF6CvZAqDHD", text: "Expertise Personalized " },
        { type: "image", src: Certificate, text: "Pakistan Freelancer Association" },
        { type: "image", src: LeapDeep, text: "Leap Deep Fest" },
        { type: "video", src: "https://www.youtube.com/embed/GhtiAK6yXeM?si=G3rzVhxtC7BVvkmi", text: "Solution Architect" },
        { type: "image", src: Slider3, text: "Global Scrum Leadership" },
        { type: "image", src: Workshop, text: "Master Enterprise Agility" }
    ];

    const plugin = useRef(Autoplay({ delay: 5000, stopOnInteraction: true }));

    const { t } = useTranslation();

    const handleMouseEnter = () => {
        plugin.current?.stop(); // Stop autoplay on hover
    };

    const handleMouseLeave = () => {
        plugin.current?.play(); // Resume autoplay when hover ends
    };

    return (
        <>
            <div>
                <p className="text-3xl text-center font-bold xs:py-20 lg:py-20 md:text-4xl lg:text-5xl">{t('videos.title')}</p>
            </div>
            <div className="flex justify-center items-center"

            >
                <Carousel
                    plugins={[plugin.current]}
                    onMouseEnter={handleMouseEnter}
                    onMouseLeave={handleMouseLeave}
                    className="xs:px-6 xs:py-0 lg:px-24 xs:h-[36vh] sm:h-[31vh] md:h-[41vh] lg:h-[41vh] xl:h-[41vh] xs:max-w-full  sm:max-w-full md:max-w-full xl:max-w-full  rounded-lg"
                >
                    <CarouselContent>
                        {media.map((item, index) => (
                            <CarouselItem key={index} className="md:basis-1/2 lg:basis-1/3">
                                <div className="p-2">
                                    <div className="flex xs:h-[30vh] sm:h-[30vh] md:h-[40vh] lg:h-[40vh] xl:h-[40vh] items-center justify-center shadow-md rounded-lg relative">
                                        {item.type === "image" ? (
                                            <div className="relative w-full h-full group">
                                                <div className="absolute top-0 left-0 w-full h-full bg-[#103469] bg-opacity-40 group-hover:bg-opacity-0 rounded-lg transition-all duration-300"></div>
                                                <img
                                                    src={item.src}
                                                    alt={`Media ${index + 1}`}
                                                    className="w-full h-full object-cover rounded-lg"
                                                />
                                                <div className="absolute bottom-0 left-0 right-0 group-hover:bg-[#103469] group-hover:bg-opacity-50 text-white p-2 text-xl font-medium text-center z-10">
                                                    {item.text}
                                                </div>
                                            </div>

                                        ) : (
                                            <div className="relative w-full h-full group">
                                                <iframe
                                                    className="w-full h-full rounded-sm group-hover:bg-opacity-0"
                                                    src={item.src}
                                                    title="YouTube video player"
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                    referrerPolicy="strict-origin-when-cross-origin"
                                                    allowFullScreen
                                                />

                                                {/* <div className="absolute top-0 left-0 w-full h-full bg-[#103469] bg-opacity-50 group-hover:bg-opacity-0 rounded-sm transition-all duration-300"></div> Color overlay */}

                                                <div className="absolute bottom-0 left-0 right-0 text-white p-2 text-xl font-medium text-center z-10">
                                                    {item.text}
                                                </div>
                                            </div>



                                        )}
                                    </div>
                                </div>
                            </CarouselItem>
                        ))}
                    </CarouselContent>
                </Carousel>
            </div>
        </>
    );
}
